import { environment } from '../../environments/environment';

const baseUrl = environment.apiBaseUrl;

export const urls = Object.freeze({  
	sitesUrl : baseUrl + "/sites",
	siteDetailsUrl :  baseUrl + "/site/{id}/details",
	sitePopupInfoUrl :  baseUrl + "/site/{id}/popup",
	trendEnterococciUrl : baseUrl + "/trend/enterococci",
	trendAnnualgradeUrl : baseUrl + "/trend/annualgrade",
	trendWatertempUrl : baseUrl + "/trend/watertemp",
	trendRainfallUrl : baseUrl + "/trend/rainfall",	
	poiSearchUrl : environment.poiSearchUrl,
	addressSearchUrl : environment.addressSearchUrl,
	addressGeometrySrvcUrl : environment.addressGeometrySrvcUrl,
	councilListUrl :  baseUrl + "/councilslist",
	regionListUrl : baseUrl + "/regionslist",
	partnerGroupListUrl : baseUrl + "/partnergroupslist", 
	partnerGroupsUrl : baseUrl + "/partnergroups", // what's the difference between partnergroupslist and partnergroups	
	siteTypesListUrl : baseUrl + "/sitetypeslist",
	subscribeUser : baseUrl + "/subscribe",	
	dataFeedsAPI : baseUrl + "/public/sites/geojson",
	dataRSSFeeds : baseUrl + "/public/sites/rss",
	downloadDataAnnualgradesCount : baseUrl + "/explore/annual_grade/count",
	downloadDataAnnualgrades : baseUrl + "/explore/annual_grade",
	downloadDataLabResultsCount : baseUrl + "/explore/lab_results/count",
	downloadDataLabResults : baseUrl + "/explore/lab_results",
	subscribeSitesList : baseUrl + "/publish-forecast-sites",
	downloadDataSitesList : baseUrl + "/data-download-sites"
});